import React from 'react';
import { connect } from 'react-redux';
import './header.css';
import Render from './render';
import { IHeaderState } from '../../definitions/header';
import { withRouter } from 'react-router';
import get from 'lodash.get';

class Header extends React.Component<any, IHeaderState> {
  private readonly brandLogo = require('../../assets/images/Leaf.svg');

  state = { mobMenuVisible: false };

  get pathname() {
    return get(this.props, 'location.pathname');
  }

  get isMenuOpen() {
    return this.state.mobMenuVisible === true
      ? 'mob-menu-open'
      : '';
  }

  toggleMobMenu = () => {
    document.body.classList.toggle('mob-menu-open');

    this.setState(s => ({
      mobMenuVisible: !s.mobMenuVisible
    }));
  };

  render() {
    return Render.call(this, this.props, this.state);
  }
}

const state = ({ menus }) => ({
  menu: menus.header
});

export default withRouter(connect(state)(Header));



// WEBPACK FOOTER //
// ./src/containers/Header/index.tsx